import { motion } from "framer-motion";

export default function ScreenLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="max-h-screen max-w-screen overflow-hidden select-none"
    >
      {children}
    </motion.div>
  );
}
